import { render } from "./Mappa.vue?vue&type=template&id=e6544bb6&scoped=true"
import script from "./Mappa.vue?vue&type=script&lang=js"
export * from "./Mappa.vue?vue&type=script&lang=js"

import "./Mappa.vue?vue&type=style&index=0&id=e6544bb6&scoped=true&lang=css"

import exportComponent from "/Users/gigi/Desktop/Progetti/ask_landing/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e6544bb6"]])

export default __exports__